import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedService } from "src/app/shareModule/services/shared.service";

@Component({
    selector: 'image-modal',
    templateUrl: './image-modal.component.html',
    styleUrls: ['./image-modal.component.scss'],
})
export class ImageModalComponent{
    public imageSrc: string;
    public descr: string;
    public cropInformation = null
    public title = '';
    constructor(private sharedService: SharedService, private modalService:NgbModal){
        
    }
    public isBottomSheet = false;

    public close(){
        this.modalService.dismissAll(); //since this is only used for chat rn
    }
    public get isMobile(): boolean {
        return this.sharedService.isBrowser() &&  window.innerWidth <= 767;
    }

}